<template>
    <div class="card-pack">
        <div class="title">消费分布
            <i class="icon-enlarge-1-o"
               @click="enlarge"
               :title='$t("放大")'
               style="cursor: pointer;"></i>
        </div>
        <div class="consume-pack">
            <div class="c-chart">
                <RadioGroup v-model="chartType"
                            type="button"
                            size="small"
                            @on-change="changeType"
                            class="chart-type">
                    <Radio label="recharge">充值金额</Radio>
                    <Radio label="order">订单支付金额</Radio>
                </RadioGroup>
                <div class="chart-pack"
                     ref="consume">
                </div>
            </div>
            <div class="c-org">
                <Tree v-if="data.length"
                      :data="treeData"
                      :render="renderContent"></Tree>
                <div v-else
                     class="no-data">暂无数据</div>
            </div>
        </div>
        <ConsumeEnlarge ref="consumeEnlarge"></ConsumeEnlarge>
    </div>
</template>

<script>
import ConsumeEnlarge from './consumeEnlarge'
import echarts from 'echarts'
export default {
    name: 'consumescatter',
    props: ['data'],
    components: {
        ConsumeEnlarge
    },
    data () {
        return {
            treeData: [],
            chartData: [{
                name: '',
                value: 0.000001,
                itemStyle: { color: '#e9e9e9' }
            }], // 默认数据只是为了显示一块有颜色的样式， 不具任何实质意义
            chartType: 'recharge'
        }
    },
    watch: {
        data () {
            this.dataChange()
        }
    },
    mounted () {
        this.initChart()
    },
    methods: {
        enlarge () { // 消费分布放大
            this.$refs.consumeEnlarge.open(this.data)
        },
        changeType () {
            if (!this.data.length) {
                return
            }
            this.chartData = this.formatChartData(this.data)
            this.initChart()
        },
        formatTreeData (val) {
            return val.map(item => {
                const children = item.orgConsumes ? this.formatTreeData(item.orgConsumes) : []
                return {
                    name: item.orgName,
                    rechargeAmount: item.rechargeAmount,
                    orderAmount: item.orderAmount,
                    billAmount: item.billAmount,
                    invoiceAmount: item.invoiceAmount,
                    children: children,
                    expand: true,
                    value: item.rechargeAmount
                }
            })
        },
        formatChartData (val) {
            return val.map(item => {
                const children = item.orgConsumes ? this.formatChartData(item.orgConsumes) : []
                const val = this.chartType === 'recharge' ? item.rechargeAmount : item.orderAmount
                return {
                    name: item.orgName,
                    children: children,
                    itemStyle: { color: val ? null : '#e9e9e9' },
                    value: [val || 0.000001, item.rechargeAmount, item.orderAmount, item.billAmount, item.invoiceAmount]
                }
            })
        },
        dataChange () {
            if (this.data.length) {
                this.treeData = [{
                    name: '账户',
                    expand: true,
                    isRoot: true,
                    children: this.formatTreeData(this.data)
                }]
                this.chartData = this.formatChartData(this.data)
            } else {
                this.chartData = [{
                    name: '',
                    value: 0.000001,
                    itemStyle: { color: '#e9e9e9' }
                }]
            }
            this.initChart()
        },
        initChart () {
            this.myChart = echarts.init(this.$refs.consume)
            const option = {
                color: ['#32c6c8', '#b5a0dd', '#5aafee', '#ff9ba1', '#8c97b1', '#f0a021', '#7dae12'],
                tooltip: {
                    formatter: (inf) => {
                        return `<div class="consume-inf">${inf.name || '账户'} <br/><span>充值金额：</span>${this.$money(inf.value[1], 5)}<br/><span>订单支付金额：</span>${this.$money(inf.value[2], 5)}<br/><span>已出账：</span>${this.$money(inf.value[3], 5)}<br/><span>已开票：</span>${this.$money(inf.value[4], 5)}</div>`
                    }
                },
                series: [{
                    name: '账户',
                    type: 'treemap',
                    visibleMin: 500,
                    data: this.chartData,
                    leafDepth: 1,
                    top: 0,
                    width: '100%',
                    height: '100%',
                    levels: [
                        {
                            itemStyle: {
                                color: 'red',
                                normal: {
                                    borderColor: '#fff',
                                    gapWidth: 0.5
                                }
                            }
                        },
                        {
                            colorSaturation: [0.3, 0.5]
                        }
                    ],
                    breadcrumb: {
                        show: !!this.data.length
                    }
                }]
            }

            this.myChart.setOption(option)
        },
        renderContent (h, { root, node, data }) {
            return h('span', {
                class: 'inf-pack'
            }, [
                h('span', [
                    h('span', data.name)
                ]),
                h('span', {
                    class: ['tr-pack', data.isRoot ? 'th' : '']
                }, data.isRoot ? [
                    h('span', '充值金额'),
                    h('span', '订单支付金额'),
                    h('span', '已出账'),
                    h('span', '已开票')
                ] : [
                    h('span', `${this.$money(data.rechargeAmount, 5)}`),
                    h('span', `${this.$money(data.orderAmount, 5)}`),
                    h('span', `${this.$money(data.billAmount, 5)}`),
                    h('span', `${this.$money(data.invoiceAmount, 5)}`)
                ])
            ])
        }
    }
}
</script>

<style lang="less" scoped>
.consume-pack {
    padding: 5px 10px 10px 10px;
    display: flex;

    .c-chart {
        width: 40%;
        .chart-type {
            margin: 5px 0 15px 0;
            display: flex;
            font-size: 12px;
            line-height: 20px;
        }
        .chart-pack {
            min-height: 240px;
            width: 100%;
        }
    }

    .c-org {
        margin-left: 50px;
        padding-left: 40px;
        border-left: 1px dashed #e9e9e9;
        flex-grow: 1;
        position: relative;
        .no-data {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 9;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
.no-data {
    padding: 30px;
    text-align: center;
}
</style>

<style lang="less">
.inf-pack {
    display: inline-block;
    width: calc(~'100% - 5px');
    .tr-pack {
        display: inline-block;
        float: right;
        width: 450px;
        margin-right: 10px;
        display: flex;
        &.th > span {
            font-size: 12px;
        }
        & > span {
            display: inline-block;
            width: 25%;
            font-size: 14px;
            font-weight: 600;
        }
    }
}
.consume-inf {
    font-size: 12px;
    padding: 5px 20px 5px 5px !important;
    & > span {
        display: inline-block;
        width: 85px;
        text-align: right;
    }
}
</style>
